<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="new-message-header">
    <div v-if="$vuetify.breakpoint.mobile" class="back-btn-container">
      <v-btn icon small class="back-btn" @click="closeConversation">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </div>
    <SmsContactNumberInput class="contact-input" :newMessageGroupMode="newMessageGroupMode" @change="handleContactChange" />
  </div>
</template>

<script>
import SmsContactNumberInput from '@/components/SmsContactNumberInput/SmsContactNumberInput';

export default {
  name: 'SmsNewMessageHeader',

  components: { SmsContactNumberInput },

  data() {
    return {
      newMessageRecipients: []
    }
  },

  props: {
    newMessageGroupMode: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    closeConversation() {
      this.$root.$emit('open-sidebar');
    },
    getNewMessageRecipients() {
      this.$root.$emit('respond-new-message-recipients', this.newMessageRecipients);
    },
    handleContactChange(contacts) {
      this.newMessageRecipients = this.processContacts(contacts);
      this.$root.$emit('new-message-recipients-list-change', this.newMessageRecipients);
    },
    processContacts(contacts) {
      let destinationList = [];
      if (contacts.length === 1) {
        if (typeof contacts[0] === 'object') {
          destinationList.push(contacts[0].number);
        } else {
          destinationList.push(contacts[0]);
        }
      } else if (contacts.length > 1) {
        contacts.forEach(c => {
          if (typeof c === 'object') {
            destinationList.push(c.number);
          } else {
            destinationList.push(c);
          }
        });
      }
      return destinationList;
    }
  },

  created() {
    this.$root.$on('request-new-message-recipients', this.getNewMessageRecipients);
  },

  beforeDestroy() {
    this.$root.$off('request-new-message-recipients');
  }
};
</script>

<style scoped>
.new-message-header {
  display: grid;
  grid-template-columns: auto;
  min-height: 60px;
  border-bottom: 1px solid var(--v-surface-border-darken1);
  box-sizing: border-box;
}

.back-btn-container {
  height: 100%;
}

.back-btn {
  width: 48px;
  height: 48px;
  margin: 6px;
}

.contact-input {
  margin-top: 1px;
}

@media (max-width: 768px) {
  .new-message-header {
    grid-template-columns: min-content auto;
  }
}
</style>
